import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { YardSpotConfigurationFacade } from './yard-spot-configuration.facade';

@Injectable({
  providedIn: 'root',
})
export class YardSpotConfigurationGuard {
  constructor(private yardSpotConfigurationFacade: YardSpotConfigurationFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { hubId },
    } = route;
    return loadStoreState(this.yardSpotConfigurationFacade, hubId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.yardSpotConfigurationFacade);
  }
}
